import {
    ChangeDetectionStrategy,
    Component,
    DestroyRef,
    inject,
    OnInit,
    output,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TelXLButtonComponent } from '@dxp/elements';
import { timer } from 'rxjs';

@Component({
    selector: 'telxl-shared-confirmation',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TelXLButtonComponent],
    templateUrl: './confirmation-panel.component.html',
    styleUrl: './confirmation-panel.component.scss',
})
export class ConfirmationPanelComponent implements OnInit {
    readonly #destroyRef = inject(DestroyRef);

    confirm = output();
    deny = output();

    ngOnInit() {
        timer(10000)
            .pipe(takeUntilDestroyed(this.#destroyRef))
            .subscribe(() => this.deny.emit());
    }
}
